import { styled, Shape, Body, LazyImage } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';
import React from 'react';
import { BlockHeader } from '../BlockHeader/BlockHeader.es.js';
import { TekoLink } from '../TekoLink/TekoLink.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCategories = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: column;
  height: 335px;
  overflow-x: scroll;
`;
const Category = styled(Shape)`
  height: 144px;
  width: 144px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  margin-right: 16px;
  margin-top: 1px;
  background: #fff;
  margin-bottom: 20px;
`;
const CategoryName = styled(Body)`
  z-index: 1;
  background-color: white;
  padding: 3px 10px;
  border-radius: 11px;
  position: relative;
  max-width: 90%;
  box-shadow: 0 4px 8px 0 #d9d9d9;
  position: absolute;
  bottom: -8px;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  font-weight: 400;
  margin-left: 6px;
`;
const BestSellingCategories = (_a) => {
  var _b = _a, {
    categories,
    title,
    isHeadingTitle = false
  } = _b, props = __objRest(_b, [
    "categories",
    "title",
    "isHeadingTitle"
  ]);
  if (!categories.length)
    return null;
  return /* @__PURE__ */ React.createElement(Shape, __spreadProps(__spreadValues({}, props), {
    backgroundColor: "white",
    paddingLeft: "s16"
  }), /* @__PURE__ */ React.createElement(BlockHeader, {
    title,
    isHeadingTitle
  }), /* @__PURE__ */ React.createElement(StyledCategories, null, categories.map((category, index) => /* @__PURE__ */ React.createElement(TekoLink, __spreadValues({
    key: index
  }, category.link), /* @__PURE__ */ React.createElement(Category, __spreadValues({}, getTrackingData({
    isTrackContent: true,
    regionName: "topCategories",
    contentName: category.id,
    target: "categoryLv2ListProduct",
    index
  })), /* @__PURE__ */ React.createElement(LazyImage, {
    contain: true,
    border: true,
    borderRadius: 8,
    src: category.image,
    alt: category.campaignName,
    imageWidth: 200
  }), /* @__PURE__ */ React.createElement(CategoryName, {
    fontSize: 12,
    maxLines: 1
  }, category.campaignName))))));
};

export { BestSellingCategories };
